import {
  TextInput,
  SelectInput,
  ReferenceInput,
  Edit,
  SimpleForm,
  required,
} from "react-admin";

import { CustomToolbar } from "../../../utils";

const validateRequired = required();

const SampleEdit= (props) => (
  <Edit redirect="list" mutationMode="pessimistic" title="Editar Amostra" {...props}>
    <SimpleForm toolbar={<CustomToolbar />}>
      <TextInput
        label="Nome"
        source="name"
        validate={validateRequired}
        resettable
      />
      <TextInput
        label="Descrição"
        source="description"
        validate={validateRequired}
        resettable
      />
      <TextInput
        placeholder="ex: https://rxpro.com.br"
        label="URL"
        source="url"
        validate={validateRequired}
        resettable
      />
      <TextInput
        label="Código da Amostra"
        source="sample_id"
        defaultValue={null}
        resettable
      />
      <ReferenceInput
        sort={{ field: "name", order: "ASC" }}
        perPage={999}
        resource="lab"
        label="Laboratório"
        source="labId"
        reference="labs"
      >
        <SelectInput optionText="name" optionValue="id" />
      </ReferenceInput>
      <TextInput
        label="Código EAN"
        source="ean"
        disabled
        format={(value) => value || "Não coletado"}
      />
    </SimpleForm>
  </Edit>
);

export default SampleEdit;
